import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "prev",
  "use": "prev-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"prev\">\r\n  <title>prev</title>\r\n  <path d=\"M14 15.299l-3.897-4.104 3.871-4.156-1-1.039L8 11.143l4.923 5.22z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol